import { render, staticRenderFns } from "./mobile.vue?vue&type=template&id=1c08b95e&scoped=true&"
import script from "./mobile.vue?vue&type=script&lang=js&"
export * from "./mobile.vue?vue&type=script&lang=js&"
import style0 from "./mobile.vue?vue&type=style&index=0&id=1c08b95e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c08b95e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c08b95e')) {
      api.createRecord('1c08b95e', component.options)
    } else {
      api.reload('1c08b95e', component.options)
    }
    module.hot.accept("./mobile.vue?vue&type=template&id=1c08b95e&scoped=true&", function () {
      api.rerender('1c08b95e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormItem/ProvinceCity/mobile.vue"
export default component.exports